import getMappedValue from "../../getMappableValue.js";
import getSelectionValue from "../getSelectionValue/index.js";
const getEventData = _ref => {
  let {
    element,
    eventData,
    product,
    contextProperties
  } = _ref;
  return {
    ...getMappedValue(eventData, element, contextProperties),
    selection: getSelectionValue(element, contextProperties),
    product,
    platform: 'web'
  };
};
export default getEventData;